var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"left-text":_vm.backText,"title":_vm.title,"left-arrow":""},on:{"click-left":_vm.onLeft},scopedSlots:_vm._u([{key:"right",fn:function(){return [_vm._t("right")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }